<template>
  <v-row no-gutters
    align="center"
    justify="center"
    class="control-toolbar pl-12">    
    <span class="current-image-eye">{{videoEye}}</span>
    <v-col cols="auto">
      <play-pause-button :isPlaying="isPlaying" @play="$emit('play')" @pause="$emit('pause')" />
    </v-col>
    <v-col cols="auto">
      <v-slider
        class="video-slider mx-3"
        :value="currentTime"
        :min="0"
        :max="duration"
        @input="$emit('setCurrentTime', $event)"
        step="0">
        <template slot="prepend">
          {{displayCurrentTime}}
        </template>
        <template slot="append">
          {{displayRemainingTime}}
        </template>
      </v-slider>
    </v-col>
    <v-col 
      cols="auto"
      v-if="!isMobile">
      <v-slider
        class="volume-slider mx-3"
        :value="volume"
        :min="0"
        :max="1"
        @input="$emit('setVolume', $event)"
        step="0" >
        <template slot="prepend">
          Volume: 
        </template>
        <template slot="append">
          {{displayVolume}}&nbsp;%
        </template>
      </v-slider>
    </v-col>
    <v-col
      cols="auto"
      v-else>
      <v-btn icon class="modal-cta mx-2" @click="$emit('toggleVideoAudio')">
        <v-icon v-if="!isMuted">fas fa fa-volume-up</v-icon>    
        <v-icon v-else>fas fa-volume-off</v-icon>
      </v-btn>
    </v-col>
  </v-row>
</template>

<script>
import { mapGetters } from "vuex";
import playPauseButton from "../controls/PlayPauseButton";
export default {
  name: "videoPlaybackToolbar",
  components: { playPauseButton },
  props: ["isPlaying", "isMuted", "currentTime", "duration", "volume"],
  computed: {
    ...mapGetters(["videoEye", "isIOS", "isOpenedInApp"]),
    displayCurrentTime(){
      return this.formatTime(Math.floor(this.currentTime));
    },
    displayRemainingTime(){
      return this.formatTime(Math.ceil(this.duration - this.currentTime));
    },
    displayVolume(){
      return Math.floor(this.volume * 100);
    },
    isMobile() {
      return this.isOpenedInApp || this.isIOS;
    }
  },
  methods: {
    formatTime(time){
      let s = Math.floor(time % 60);
      let m = Math.floor(time / 60);
      return this.pad(m) + ":" + this.pad(s);
    },
    pad(number){
      return (number + "").padStart(2, "0");
    }
  }
};
</script>
